import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=3de5bbed&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=3de5bbed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de5bbed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de5bbed')) {
      api.createRecord('3de5bbed', component.options)
    } else {
      api.reload('3de5bbed', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=3de5bbed&scoped=true&", function () {
      api.rerender('3de5bbed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BYkyZ1tX9mmR/JS/comp/GuestBox.vue"
export default component.exports